// src/api/getData.js

async function getData(api) {
	try {
		const response = await fetch(api);
		const data = await response.json();
		return data;
	} catch (error) {
		console.error("Error fetching data:", error);
		return [];
	}
}

export async function incomeStatementsData(symbol) {
	const data = await getData(
		`https://financialmodelingprep.com/api/v3/income-statement/${symbol}?period=annual&limit=4&apikey=0OlXvaWXwLdmZ7CM5vXed2rGuuyn17gy`
	);
	const incomeStatementsData = {
		2023: {
			Revenue: [data[0].revenue, "bold underlined with-bottom-border"],
			"Cost of Goods Sold": [data[0].costOfRevenue, "bold"],
			"Gross Profit": [
				data[0].grossProfit,
				"bold underlined with-bottom-border",
			],
			"SG&A Expense": [
				data[0].sellingGeneralAndAdministrativeExpenses,
				"bold",
			],
			"Research & Development Expense": [
				data[0].researchAndDevelopmentExpenses,
				"bold",
			],
			"Operating Interest Expense": [data[0].interestExpense, "indented"],
			"Net Operating Interest Income": [data[0].interestIncome, "bold"],
			"Total Operating Expenses": [data[0].operatingExpenses, "bold"],
			"Operating Income": [data[0].operatingIncome, "bold"],
			"Non-Operating Interest Expense": [
				data[0].interestExpense,
				"indented",
			],
			"Net Non-Operating Interest Income Expense": [
				data[0].interestIncome,
				"bold",
			],
			"Other Income & Expenses": [
				data[0].totalOtherIncomeExpensesNet,
				"indented",
			],
			"Net Interest Income": [data[0].interestIncome, "bold"],
			"Pre-Tax Income": [data[0].incomeBeforeTax, "bold"],
			"Provision for Income Taxes": [data[0].incomeTaxExpense, "bold"],
			"Income from Continuing Operations": [
				data[0].netIncome,
				"indented",
			],
			"Net Income": [
				data[0].netIncome,
				"bold underlined with-bottom-border",
			],
			"Normalized Income": [data[0].netIncome, "indented"],
			EBITDA: [data[0].ebitda, "indented"],
			"Reconciled Depreciation": [
				data[0].depreciationAndAmortization,
				"indented",
			],
			EBIT: [
				data[0].ebitda - data[0].depreciationAndAmortization,
				"indented",
			],
			"Basic EPS": ["2023", "header-row"],
			"EPS Basic from Continuing Operations": [data[0].eps, "indented"],
			"Normalized Basic EPS": [data[0].eps, "indented"],
			"EPS Basic": [data[0].eps, "indented"],
			"Diluted EPS": ["2023", "header-row"],
			"EPS Diluted from Continuing Operations": [
				data[0].epsdiluted,
				"indented",
			],
			"Normalized Diluted EPS": [data[0].epsdiluted, "indented"],
			"EPS Diluted": [data[0].epsdiluted, "indented"],
			"Shares Data": ["2023", "header-row"],
			"Average Basic Shares Outstanding": [
				data[0].weightedAverageShsOut,
				"indented",
			],
			"Average Diluted Shares Outstanding": [
				data[0].weightedAverageShsOutDil,
				"indented",
			],
			// 'Dividend Per Share': [data[0]., 'indented'],
		},
		2022: {
			Revenue: [data[1].revenue, "bold underlined with-bottom-border"],
			"Cost of Goods Sold": [data[1].costOfRevenue, "bold"],
			"Gross Profit": [
				data[1].grossProfit,
				"bold underlined with-bottom-border",
			],
			"SG&A Expense": [
				data[1].sellingGeneralAndAdministrativeExpenses,
				"bold",
			],
			"Research & Development Expense": [
				data[1].researchAndDevelopmentExpenses,
				"bold",
			],
			"Operating Interest Expense": [data[1].interestExpense, "indented"],
			"Net Operating Interest Income": [data[1].interestIncome, "bold"],
			"Total Operating Expenses": [data[1].operatingExpenses, "bold"],
			"Operating Income": [data[1].operatingIncome, "bold"],
			"Non-Operating Interest Expense": [
				data[1].interestExpense,
				"indented",
			],
			"Net Non-Operating Interest Income Expense": [
				data[1].interestIncome,
				"bold",
			],
			"Other Income & Expenses": [
				data[1].totalOtherIncomeExpensesNet,
				"indented",
			],
			"Net Interest Income": [data[1].interestIncome, "bold"],
			"Pre-Tax Income": [data[1].incomeBeforeTax, "bold"],
			"Provision for Income Taxes": [data[1].incomeTaxExpense, "bold"],
			"Income from Continuing Operations": [
				data[1].netIncome,
				"indented",
			],
			"Net Income": [
				data[1].netIncome,
				"bold underlined with-bottom-border",
			],
			"Normalized Income": [data[1].netIncome, "indented"],
			EBITDA: [data[1].ebitda, "indented"],
			"Reconciled Depreciation": [
				data[1].depreciationAndAmortization,
				"indented",
			],
			EBIT: [
				data[1].ebitda - data[1].depreciationAndAmortization,
				"indented",
			],
			"Basic EPS": ["2022", "header-row"],
			"EPS Basic from Continuing Operations": [data[1].eps, "indented"],
			"Normalized Basic EPS": [data[1].eps, "indented"],
			"EPS Basic": [data[1].eps, "indented"],
			"Diluted EPS": ["2022", "header-row"],
			"EPS Diluted from Continuing Operations": [
				data[1].epsdiluted,
				"indented",
			],
			"Normalized Diluted EPS": [data[1].epsdiluted, "indented"],
			"EPS Diluted": [data[1].epsdiluted, "indented"],
			"Shares Data": ["2022", "header-row"],
			"Average Basic Shares Outstanding": [
				data[1].weightedAverageShsOut,
				"indented",
			],
			"Average Diluted Shares Outstanding": [
				data[1].weightedAverageShsOutDil,
				"indented",
			],
			// 'Dividend Per Share': [data[0]., 'indented'],
		},
		2021: {
			Revenue: [data[2].revenue, "bold underlined with-bottom-border"],
			"Cost of Goods Sold": [data[2].costOfRevenue, "bold"],
			"Gross Profit": [
				data[2].grossProfit,
				"bold underlined with-bottom-border",
			],
			"SG&A Expense": [
				data[2].sellingGeneralAndAdministrativeExpenses,
				"bold",
			],
			"Research & Development Expense": [
				data[2].researchAndDevelopmentExpenses,
				"bold",
			],
			"Operating Interest Expense": [data[2].interestExpense, "indented"],
			"Net Operating Interest Income": [data[2].interestIncome, "bold"],
			"Total Operating Expenses": [data[2].operatingExpenses, "bold"],
			"Operating Income": [data[2].operatingIncome, "bold"],
			"Non-Operating Interest Expense": [
				data[2].interestExpense,
				"indented",
			],
			"Net Non-Operating Interest Income Expense": [
				data[2].interestIncome,
				"bold",
			],
			"Other Income & Expenses": [
				data[2].totalOtherIncomeExpensesNet,
				"indented",
			],
			"Net Interest Income": [data[2].interestIncome, "bold"],
			"Pre-Tax Income": [data[2].incomeBeforeTax, "bold"],
			"Provision for Income Taxes": [data[2].incomeTaxExpense, "bold"],
			"Income from Continuing Operations": [
				data[2].netIncome,
				"indented",
			],
			"Net Income": [
				data[2].netIncome,
				"bold underlined with-bottom-border",
			],
			"Normalized Income": [data[2].netIncome, "indented"],
			EBITDA: [data[2].ebitda, "indented"],
			"Reconciled Depreciation": [
				data[2].depreciationAndAmortization,
				"indented",
			],
			EBIT: [
				data[2].ebitda - data[2].depreciationAndAmortization,
				"indented",
			],
			"Basic EPS": ["2021", "header-row"],
			"EPS Basic from Continuing Operations": [data[2].eps, "indented"],
			"Normalized Basic EPS": [data[2].eps, "indented"],
			"EPS Basic": [data[2].eps, "indented"],
			"Diluted EPS": ["2021", "header-row"],
			"EPS Diluted from Continuing Operations": [
				data[2].epsdiluted,
				"indented",
			],
			"Normalized Diluted EPS": [data[2].epsdiluted, "indented"],
			"EPS Diluted": [data[2].epsdiluted, "indented"],
			"Shares Data": ["2021", "header-row"],
			"Average Basic Shares Outstanding": [
				data[2].weightedAverageShsOut,
				"indented",
			],
			"Average Diluted Shares Outstanding": [
				data[2].weightedAverageShsOutDil,
				"indented",
			],
			// 'Dividend Per Share': [data[0]., 'indented'],
		},
		2020: {
			Revenue: [data[3].revenue, "bold underlined with-bottom-border"],
			"Cost of Goods Sold": [data[3].costOfRevenue, "bold"],
			"Gross Profit": [
				data[3].grossProfit,
				"bold underlined with-bottom-border",
			],
			"SG&A Expense": [
				data[3].sellingGeneralAndAdministrativeExpenses,
				"bold",
			],
			"Research & Development Expense": [
				data[3].researchAndDevelopmentExpenses,
				"bold",
			],
			"Operating Interest Expense": [data[3].interestExpense, "indented"],
			"Net Operating Interest Income": [data[3].interestIncome, "bold"],
			"Total Operating Expenses": [data[3].operatingExpenses, "bold"],
			"Operating Income": [data[3].operatingIncome, "bold"],
			"Non-Operating Interest Expense": [
				data[3].interestExpense,
				"indented",
			],
			"Net Non-Operating Interest Income Expense": [
				data[3].interestIncome,
				"bold",
			],
			"Other Income & Expenses": [
				data[3].totalOtherIncomeExpensesNet,
				"indented",
			],
			"Net Interest Income": [data[3].interestIncome, "bold"],
			"Pre-Tax Income": [data[3].incomeBeforeTax, "bold"],
			"Provision for Income Taxes": [data[3].incomeTaxExpense, "bold"],
			"Income from Continuing Operations": [
				data[3].netIncome,
				"indented",
			],
			"Net Income": [
				data[3].netIncome,
				"bold underlined with-bottom-border",
			],
			"Normalized Income": [data[3].netIncome, "indented"],
			EBITDA: [data[3].ebitda, "indented"],
			"Reconciled Depreciation": [
				data[3].depreciationAndAmortization,
				"indented",
			],
			EBIT: [
				data[3].ebitda - data[3].depreciationAndAmortization,
				"indented",
			],
			"Basic EPS": ["2020", "header-row"],
			"EPS Basic from Continuing Operations": [data[3].eps, "indented"],
			"Normalized Basic EPS": [data[3].eps, "indented"],
			"EPS Basic": [data[3].eps, "indented"],
			"Diluted EPS": ["2020", "header-row"],
			"EPS Diluted from Continuing Operations": [
				data[3].epsdiluted,
				"indented",
			],
			"Normalized Diluted EPS": [data[3].epsdiluted, "indented"],
			"EPS Diluted": [data[3].epsdiluted, "indented"],
			"Shares Data": ["2020", "header-row"],
			"Average Basic Shares Outstanding": [
				data[3].weightedAverageShsOut,
				"indented",
			],
			"Average Diluted Shares Outstanding": [
				data[3].weightedAverageShsOutDil,
				"indented",
			],
			// 'Dividend Per Share': [data[0]., 'indented'],
		},
	};
	return incomeStatementsData;
}

export async function balanceSheetData(symbol) {
	const data = await getData(
		`https://financialmodelingprep.com/api/v3/balance-sheet-statement/${symbol}?period=annual&limit=4&apikey=0OlXvaWXwLdmZ7CM5vXed2rGuuyn17gy`
	);
	const balanceSheetData = {
		2023: {
			// 'Cash': [data[0]., 'indented'],
			"Cash & Equivalents": [data[0].cashAndCashEquivalents, "indented"],
			"Short Term Investments": [
				data[0].shortTermInvestments,
				"indented",
			],
			"Cash & Short Term Investments": [
				data[0].cashAndShortTermInvestments,
				"bold",
			],
			// 'Accounts Receivables': [data[0]., 'indented'],
			// 'Other Receivables': [data[0]., 'indented'],
			"Total Receivables": [data[0].netReceivables, "bold"],
			Inventories: [data[0].inventory, "bold"],
			"Other Current Assets": [data[0].otherCurrentAssets, "indented"],
			"Total Current Assets": [
				data[0].totalCurrentAssets,
				"bold underlined with-bottom-border",
			],
			// 'Land & Improvements': [data[0]., 'indented'],
			// 'Machine, Furniture & Equipment': [data[0]., 'indented'],
			// 'Other Properties': [data[0]., 'indented'],
			// 'Gross PP&E': [data[0]., 'bold'],
			// 'Accumulated D&A': [data[0]., 'indented'],
			Goodwill: [data[0].goodwill, "indented"],
			"Other Intangible Assets": [data[0].intangibleAssets, "indented"],
			"Goodwill & Intangibles": [
				data[0].goodwillAndIntangibleAssets,
				"bold",
			],
			"Long Term Investments": [data[0].longTermInvestments, "indented"],
			"Long Term Deferred Assets": [data[0].taxAssets, "indented"],
			"Other Long Term Assets": [
				data[0].otherNonCurrentAssets,
				"indented",
			],
			"Total Long Term Assets": [data[0].totalNonCurrentAssets, "bold"],
			"Total Assets": [data[0].totalAssets, "bold"],
			Liabilities: ["2023", "header-row"],
			"Accounts Payable": [data[0].accountPayables, "indented"],
			// 'Total Payables': [data[0]., 'bold'],
			// 'Accrued Expenses': [data[0]., 'indented'],
			// 'Payables and Accrued Expenses': [data[0]., 'bold'],
			// 'Other Current Borrowings': [data[0]., 'indented'],
			// 'Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Current Debt & Capital Lease Obligation': [data[0]., 'bold'],
			"Current Deferred Revenue": [data[0].deferredRevenue, "indented"],
			"Current Deferred Liabilities": [data[0].deferredRevenue, "bold"],
			"Other Current Liabilities": [
				data[0].otherCurrentLiabilities,
				"indented",
			],
			"Total Current Liabilities": [
				data[0].totalCurrentLiabilities,
				"bold underlined with-bottom-border",
			],
			// 'Non-Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Non-Current Portion of LTD and Capital Lease Obligation': [data[0]., 'bold'],
			"Long Term Deferred Tax Liabilities": [
				data[0].deferredTaxLiabilitiesNonCurrent,
				"indented",
			],
			"Non-Current Deferred Liabilities": [
				data[0].deferredRevenueNonCurrent,
				"bold",
			],
			"Long Term Cap Lease Obligation": [
				data[0].capitalLeaseObligations,
				"indented",
			],
			"Other Long Term Liabilities": [
				data[0].otherNonCurrentLiabilities,
				"indented",
			],
			"Total Long Term Liabilities": [
				data[0].totalNonCurrentLiabilities,
				"bold",
			],
			"Total Liabilities": [data[0].totalLiabilities, "bold"],
			"Shareholder's Equity": ["2023", "header-row"],
			"Total Capital Stock": [data[0].commonStock, "indented"],
			"Retained Earnings": [data[0].retainedEarnings, "indented"],
			"Accrued Comprehensive Inc": [
				data[0].accumulatedOtherComprehensiveIncomeLoss,
				"bold",
			],
			"Shareholders Equity": [data[0].totalStockholdersEquity, "bold"],
		},
		2022: {
			// 'Cash': [data[0]., 'indented'],
			"Cash & Equivalents": [data[1].cashAndCashEquivalents, "indented"],
			"Short Term Investments": [
				data[1].shortTermInvestments,
				"indented",
			],
			"Cash & Short Term Investments": [
				data[1].cashAndShortTermInvestments,
				"bold",
			],
			// 'Accounts Receivables': [data[0]., 'indented'],
			// 'Other Receivables': [data[0]., 'indented'],
			"Total Receivables": [data[1].netReceivables, "bold"],
			Inventories: [data[1].inventory, "bold"],
			"Other Current Assets": [data[1].otherCurrentAssets, "indented"],
			"Total Current Assets": [
				data[1].totalCurrentAssets,
				"bold underlined with-bottom-border",
			],
			// 'Land & Improvements': [data[0]., 'indented'],
			// 'Machine, Furniture & Equipment': [data[0]., 'indented'],
			// 'Other Properties': [data[0]., 'indented'],
			// 'Gross PP&E': [data[0]., 'bold'],
			// 'Accumulated D&A': [data[0]., 'indented'],
			Goodwill: [data[1].goodwill, "indented"],
			"Other Intangible Assets": [data[1].intangibleAssets, "indented"],
			"Goodwill & Intangibles": [
				data[1].goodwillAndIntangibleAssets,
				"bold",
			],
			"Long Term Investments": [data[1].longTermInvestments, "indented"],
			"Long Term Deferred Assets": [data[1].taxAssets, "indented"],
			"Other Long Term Assets": [
				data[1].otherNonCurrentAssets,
				"indented",
			],
			"Total Long Term Assets": [data[1].totalNonCurrentAssets, "bold"],
			"Total Assets": [data[1].totalAssets, "bold"],
			Liabilities: ["2022", "header-row"],
			"Accounts Payable": [data[1].accountPayables, "indented"],
			// 'Total Payables': [data[0]., 'bold'],
			// 'Accrued Expenses': [data[0]., 'indented'],
			// 'Payables and Accrued Expenses': [data[0]., 'bold'],
			// 'Other Current Borrowings': [data[0]., 'indented'],
			// 'Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Current Debt & Capital Lease Obligation': [data[0]., 'bold'],
			"Current Deferred Revenue": [data[1].deferredRevenue, "indented"],
			"Current Deferred Liabilities": [data[1].deferredRevenue, "bold"],
			"Other Current Liabilities": [
				data[1].otherCurrentLiabilities,
				"indented",
			],
			"Total Current Liabilities": [
				data[1].totalCurrentLiabilities,
				"bold underlined with-bottom-border",
			],
			// 'Non-Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Non-Current Portion of LTD and Capital Lease Obligation': [data[0]., 'bold'],
			"Long Term Deferred Tax Liabilities": [
				data[1].deferredTaxLiabilitiesNonCurrent,
				"indented",
			],
			"Non-Current Deferred Liabilities": [
				data[1].deferredRevenueNonCurrent,
				"bold",
			],
			"Long Term Cap Lease Obligation": [
				data[1].capitalLeaseObligations,
				"indented",
			],
			"Other Long Term Liabilities": [
				data[1].otherNonCurrentLiabilities,
				"indented",
			],
			"Total Long Term Liabilities": [
				data[1].totalNonCurrentLiabilities,
				"bold",
			],
			"Total Liabilities": [data[1].totalLiabilities, "bold"],
			"Shareholder's Equity": ["2022", "header-row"],
			"Total Capital Stock": [data[1].commonStock, "indented"],
			"Retained Earnings": [data[1].retainedEarnings, "indented"],
			"Accrued Comprehensive Inc": [
				data[1].accumulatedOtherComprehensiveIncomeLoss,
				"bold",
			],
			"Shareholders Equity": [data[1].totalStockholdersEquity, "bold"],
		},
		2021: {
			// 'Cash': [data[0]., 'indented'],
			"Cash & Equivalents": [data[2].cashAndCashEquivalents, "indented"],
			"Short Term Investments": [
				data[2].shortTermInvestments,
				"indented",
			],
			"Cash & Short Term Investments": [
				data[2].cashAndShortTermInvestments,
				"bold",
			],
			// 'Accounts Receivables': [data[0]., 'indented'],
			// 'Other Receivables': [data[0]., 'indented'],
			"Total Receivables": [data[2].netReceivables, "bold"],
			Inventories: [data[2].inventory, "bold"],
			"Other Current Assets": [data[2].otherCurrentAssets, "indented"],
			"Total Current Assets": [
				data[2].totalCurrentAssets,
				"bold underlined with-bottom-border",
			],
			// 'Land & Improvements': [data[0]., 'indented'],
			// 'Machine, Furniture & Equipment': [data[0]., 'indented'],
			// 'Other Properties': [data[0]., 'indented'],
			// 'Gross PP&E': [data[0]., 'bold'],
			// 'Accumulated D&A': [data[0]., 'indented'],
			Goodwill: [data[2].goodwill, "indented"],
			"Other Intangible Assets": [data[2].intangibleAssets, "indented"],
			"Goodwill & Intangibles": [
				data[2].goodwillAndIntangibleAssets,
				"bold",
			],
			"Long Term Investments": [data[2].longTermInvestments, "indented"],
			"Long Term Deferred Assets": [data[2].taxAssets, "indented"],
			"Other Long Term Assets": [
				data[2].otherNonCurrentAssets,
				"indented",
			],
			"Total Long Term Assets": [data[2].totalNonCurrentAssets, "bold"],
			"Total Assets": [data[2].totalAssets, "bold"],
			Liabilities: ["2021", "header-row"],
			"Accounts Payable": [data[2].accountPayables, "indented"],
			// 'Total Payables': [data[0]., 'bold'],
			// 'Accrued Expenses': [data[0]., 'indented'],
			// 'Payables and Accrued Expenses': [data[0]., 'bold'],
			// 'Other Current Borrowings': [data[0]., 'indented'],
			// 'Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Current Debt & Capital Lease Obligation': [data[0]., 'bold'],
			"Current Deferred Revenue": [data[2].deferredRevenue, "indented"],
			"Current Deferred Liabilities": [data[2].deferredRevenue, "bold"],
			"Other Current Liabilities": [
				data[2].otherCurrentLiabilities,
				"indented",
			],
			"Total Current Liabilities": [
				data[2].totalCurrentLiabilities,
				"bold underlined with-bottom-border",
			],
			// 'Non-Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Non-Current Portion of LTD and Capital Lease Obligation': [data[0]., 'bold'],
			"Long Term Deferred Tax Liabilities": [
				data[2].deferredTaxLiabilitiesNonCurrent,
				"indented",
			],
			"Non-Current Deferred Liabilities": [
				data[2].deferredRevenueNonCurrent,
				"bold",
			],
			"Long Term Cap Lease Obligation": [
				data[2].capitalLeaseObligations,
				"indented",
			],
			"Other Long Term Liabilities": [
				data[2].otherNonCurrentLiabilities,
				"indented",
			],
			"Total Long Term Liabilities": [
				data[2].totalNonCurrentLiabilities,
				"bold",
			],
			"Total Liabilities": [data[2].totalLiabilities, "bold"],
			"Shareholder's Equity": ["2021", "header-row"],
			"Total Capital Stock": [data[2].commonStock, "indented"],
			"Retained Earnings": [data[2].retainedEarnings, "indented"],
			"Accrued Comprehensive Inc": [
				data[2].accumulatedOtherComprehensiveIncomeLoss,
				"bold",
			],
			"Shareholders Equity": [data[2].totalStockholdersEquity, "bold"],
		},
		2020: {
			// 'Cash': [data[0]., 'indented'],
			"Cash & Equivalents": [data[3].cashAndCashEquivalents, "indented"],
			"Short Term Investments": [
				data[3].shortTermInvestments,
				"indented",
			],
			"Cash & Short Term Investments": [
				data[3].cashAndShortTermInvestments,
				"bold",
			],
			// 'Accounts Receivables': [data[0]., 'indented'],
			// 'Other Receivables': [data[0]., 'indented'],
			"Total Receivables": [data[3].netReceivables, "bold"],
			Inventories: [data[3].inventory, "bold"],
			"Other Current Assets": [data[3].otherCurrentAssets, "indented"],
			"Total Current Assets": [
				data[3].totalCurrentAssets,
				"bold underlined with-bottom-border",
			],
			// 'Land & Improvements': [data[0]., 'indented'],
			// 'Machine, Furniture & Equipment': [data[0]., 'indented'],
			// 'Other Properties': [data[0]., 'indented'],
			// 'Gross PP&E': [data[0]., 'bold'],
			// 'Accumulated D&A': [data[0]., 'indented'],
			Goodwill: [data[3].goodwill, "indented"],
			"Other Intangible Assets": [data[3].intangibleAssets, "indented"],
			"Goodwill & Intangibles": [
				data[3].goodwillAndIntangibleAssets,
				"bold",
			],
			"Long Term Investments": [data[3].longTermInvestments, "indented"],
			"Long Term Deferred Assets": [data[3].taxAssets, "indented"],
			"Other Long Term Assets": [
				data[3].otherNonCurrentAssets,
				"indented",
			],
			"Total Long Term Assets": [data[3].totalNonCurrentAssets, "bold"],
			"Total Assets": [data[3].totalAssets, "bold"],
			Liabilities: ["2020", "header-row"],
			"Accounts Payable": [data[3].accountPayables, "indented"],
			// 'Total Payables': [data[0]., 'bold'],
			// 'Accrued Expenses': [data[0]., 'indented'],
			// 'Payables and Accrued Expenses': [data[0]., 'bold'],
			// 'Other Current Borrowings': [data[0]., 'indented'],
			// 'Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Current Debt & Capital Lease Obligation': [data[0]., 'bold'],
			"Current Deferred Revenue": [data[3].deferredRevenue, "indented"],
			"Current Deferred Liabilities": [data[3].deferredRevenue, "bold"],
			"Other Current Liabilities": [
				data[3].otherCurrentLiabilities,
				"indented",
			],
			"Total Current Liabilities": [
				data[3].totalCurrentLiabilities,
				"bold underlined with-bottom-border",
			],
			// 'Non-Current Portion of Long Term Debt': [data[0]., 'indented'],
			// 'Non-Current Portion of LTD and Capital Lease Obligation': [data[0]., 'bold'],
			"Long Term Deferred Tax Liabilities": [
				data[3].deferredTaxLiabilitiesNonCurrent,
				"indented",
			],
			"Non-Current Deferred Liabilities": [
				data[3].deferredRevenueNonCurrent,
				"bold",
			],
			"Long Term Cap Lease Obligation": [
				data[3].capitalLeaseObligations,
				"indented",
			],
			"Other Long Term Liabilities": [
				data[3].otherNonCurrentLiabilities,
				"indented",
			],
			"Total Long Term Liabilities": [
				data[3].totalNonCurrentLiabilities,
				"bold",
			],
			"Total Liabilities": [data[3].totalLiabilities, "bold"],
			"Shareholder's Equity": ["2020", "header-row"],
			"Total Capital Stock": [data[3].commonStock, "indented"],
			"Retained Earnings": [data[3].retainedEarnings, "indented"],
			"Accrued Comprehensive Inc": [
				data[3].accumulatedOtherComprehensiveIncomeLoss,
				"bold",
			],
			"Shareholders Equity": [data[3].totalStockholdersEquity, "bold"],
		},
	};
	return balanceSheetData;
}

export async function cashFlowData(symbol) {
	const data = await getData(
		`https://financialmodelingprep.com/api/v3/cash-flow-statement/${symbol}?period=annual&limit=4&apikey=0OlXvaWXwLdmZ7CM5vXed2rGuuyn17gy`
	);
	const cashFlowData = {
		2023: {
			"Net Income": [data[0].netIncome, "bold"],
			"Total Depreciation & Amortization": [
				data[0].depreciationAndAmortization,
				"bold",
			],
			"Total Depreciation, Amortization & Depletion": [
				data[0].depreciationAndAmortization,
				"bold",
			],
			"Deferred Taxes": [data[0].deferredIncomeTax, "indented"],
			"Stock Based Compensation": [
				data[0].stockBasedCompensation,
				"indented",
			],
			"Other Noncash Items": [data[0].otherNonCashItems, "indented"],
			"Change in Receivables": [data[0].accountsReceivables, "indented"],
			"Change in Inventories": [data[0].inventory, "indented"],
			"Change in Payables and Accrued Expense": [
				data[0].accountsPayables,
				"indented",
			],
			"Change in Other Working Capital": [
				data[0].otherWorkingCapital,
				"indented",
			],
			"Change in Working Capital": [
				data[0].changeInWorkingCapital,
				"indented",
			],
			"Cash from Operations": [
				data[0].operatingCashFlow,
				"bold underlined",
			],
			"Cash Flow - Investing": ["2023", "header-row"],
			"Capital Expenditures": [
				data[0].capitalExpenditure,
				"bold underlined",
			],
			"Free Cash Flow": [
				data[0].freeCashFlow,
				"bold underlined with-borders",
			],
			"Acquisitions / Depositions": [data[0].acquisitionsNet, "indented"],
			"Cash from Investing": [
				data[0].netCashUsedProvidedByFinancingActivities,
				"bold",
			],
			"Ending Cash": ["2023", "header-row"],
			"Beginning Cash": [data[0].cashAtBeginningOfPeriod, "indented"],
			"Change in Cash": [data[0].netChangeInCash, "indented"],
			"Enging Cash": [data[0].cashAtEndOfPeriod, "indented"],
		},
		2022: {
			"Net Income": [data[1].netIncome, "bold"],
			"Total Depreciation & Amortization": [
				data[1].depreciationAndAmortization,
				"bold",
			],
			"Total Depreciation, Amortization & Depletion": [
				data[1].depreciationAndAmortization,
				"bold",
			],
			"Deferred Taxes": [data[1].deferredIncomeTax, "indented"],
			"Stock Based Compensation": [
				data[1].stockBasedCompensation,
				"indented",
			],
			"Other Noncash Items": [data[1].otherNonCashItems, "indented"],
			"Change in Receivables": [data[1].accountsReceivables, "indented"],
			"Change in Inventories": [data[1].inventory, "indented"],
			"Change in Payables and Accrued Expense": [
				data[1].accountsPayables,
				"indented",
			],
			"Change in Other Working Capital": [
				data[1].otherWorkingCapital,
				"indented",
			],
			"Change in Working Capital": [
				data[1].changeInWorkingCapital,
				"indented",
			],
			"Cash from Operations": [
				data[1].operatingCashFlow,
				"bold underlined",
			],
			"Cash Flow - Investing": ["2022", "header-row"],
			"Capital Expenditures": [
				data[1].capitalExpenditure,
				"bold underlined",
			],
			"Free Cash Flow": [
				data[1].freeCashFlow,
				"bold underlined with-borders",
			],
			"Acquisitions / Depositions": [data[1].acquisitionsNet, "indented"],
			"Cash from Investing": [
				data[1].netCashUsedProvidedByFinancingActivities,
				"bold",
			],
			"Ending Cash": ["2022", "header-row"],
			"Beginning Cash": [data[1].cashAtBeginningOfPeriod, "indented"],
			"Change in Cash": [data[1].netChangeInCash, "indented"],
			"Enging Cash": [data[1].cashAtEndOfPeriod, "indented"],
		},
		2021: {
			"Net Income": [data[2].netIncome, "bold"],
			"Total Depreciation & Amortization": [
				data[2].depreciationAndAmortization,
				"bold",
			],
			"Total Depreciation, Amortization & Depletion": [
				data[2].depreciationAndAmortization,
				"bold",
			],
			"Deferred Taxes": [data[2].deferredIncomeTax, "indented"],
			"Stock Based Compensation": [
				data[2].stockBasedCompensation,
				"indented",
			],
			"Other Noncash Items": [data[2].otherNonCashItems, "indented"],
			"Change in Receivables": [data[2].accountsReceivables, "indented"],
			"Change in Inventories": [data[2].inventory, "indented"],
			"Change in Payables and Accrued Expense": [
				data[2].accountsPayables,
				"indented",
			],
			"Change in Other Working Capital": [
				data[2].otherWorkingCapital,
				"indented",
			],
			"Change in Working Capital": [
				data[2].changeInWorkingCapital,
				"indented",
			],
			"Cash from Operations": [
				data[2].operatingCashFlow,
				"bold underlined",
			],
			"Cash Flow - Investing": ["2021", "header-row"],
			"Capital Expenditures": [
				data[2].capitalExpenditure,
				"bold underlined",
			],
			"Free Cash Flow": [
				data[2].freeCashFlow,
				"bold underlined with-borders",
			],
			"Acquisitions / Depositions": [data[2].acquisitionsNet, "indented"],
			"Cash from Investing": [
				data[2].netCashUsedProvidedByFinancingActivities,
				"bold",
			],
			"Ending Cash": ["2021", "header-row"],
			"Beginning Cash": [data[2].cashAtBeginningOfPeriod, "indented"],
			"Change in Cash": [data[2].netChangeInCash, "indented"],
			"Enging Cash": [data[2].cashAtEndOfPeriod, "indented"],
		},
		2020: {
			"Net Income": [data[3].netIncome, "bold"],
			"Total Depreciation & Amortization": [
				data[3].depreciationAndAmortization,
				"bold",
			],
			"Total Depreciation, Amortization & Depletion": [
				data[3].depreciationAndAmortization,
				"bold",
			],
			"Deferred Taxes": [data[3].deferredIncomeTax, "indented"],
			"Stock Based Compensation": [
				data[3].stockBasedCompensation,
				"indented",
			],
			"Other Noncash Items": [data[3].otherNonCashItems, "indented"],
			"Change in Receivables": [data[3].accountsReceivables, "indented"],
			"Change in Inventories": [data[3].inventory, "indented"],
			"Change in Payables and Accrued Expense": [
				data[3].accountsPayables,
				"indented",
			],
			"Change in Other Working Capital": [
				data[3].otherWorkingCapital,
				"indented",
			],
			"Change in Working Capital": [
				data[3].changeInWorkingCapital,
				"indented",
			],
			"Cash from Operations": [
				data[3].operatingCashFlow,
				"bold underlined",
			],
			"Cash Flow - Investing": ["2020", "header-row"],
			"Capital Expenditures": [
				data[3].capitalExpenditure,
				"bold underlined",
			],
			"Free Cash Flow": [
				data[3].freeCashFlow,
				"bold underlined with-borders",
			],
			"Acquisitions / Depositions": [data[3].acquisitionsNet, "indented"],
			"Cash from Investing": [
				data[3].netCashUsedProvidedByFinancingActivities,
				"bold",
			],
			"Ending Cash": ["2020", "header-row"],
			"Beginning Cash": [data[3].cashAtBeginningOfPeriod, "indented"],
			"Change in Cash": [data[3].netChangeInCash, "indented"],
			"Enging Cash": [data[3].cashAtEndOfPeriod, "indented"],
		},
	};
	return cashFlowData;
}
